import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Type} from '../models/train';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TrainTypeDataService {

  constructor(private http: HttpClient) { }

  getTrainsTypeslist= (projectId: number): Observable<Type[]> => {
    return this.http.get<Type[]>(`${environment.api.baseUrl}/${environment.api.endpoints.train.trainConfig}/traintypes?projectId=${projectId}`);
  }

  getTrainTypeConfiguration= (projectId: number, trainId: number): Observable<any> => {
    return this.http.get<any>(`${environment.api.baseUrl}/${environment.api.endpoints.project.projectList}/${projectId}/trains/${trainId}/configuration`);
  }
}

